import React from "react";
import { BsArrowRight } from "react-icons/bs";
import HtmlParser from "react-html-parser";

function OurProducts({ Products, ListProduct, limit = 6, index = 0 }) {
  return (
    <div>
      <div className="our-products">
        <div className="container">
          <div className="row mt-5">
            <div className="banner-txt">
              <p className="banner-num">05</p>
              <span className="banner-title">Our Products</span>
            </div>
          </div>
          <div className="row mt-3">
            <p className="txt2 ">{Products?.ProductTitle}</p>
          </div>
          <div className="row mt-5 d-flex center ">
            <p className="txt3  col-md-8 col-lg-9 p-0">
              {HtmlParser(Products?.ProductContent)}
            </p>
            <div className="col-md-4 col-lg-3 pl-3 our-pro-btn p-0">
              <a href="/products" className="btn2 btn2-color btn2-l-r ">
                View All &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <BsArrowRight />
              </a>
            </div>
          </div>
          <div className="row mt-5">
            {ListProduct?.data?.slice(index, limit)?.map((datas) => (
              <div
                className="col-6 col-sm-12 col-md-6 col-lg-4 p-0 our-pro"
                key={datas.id}
              >
                <a href={"/product-detail/" + datas?.attributes?.Slug}>
                  <div className=" Our-pro-img text-center">
                    <img
                      className="img-responsive p-2"
                      src={
                        process.env.REACT_APP_IMAGE_BASE_URL +
                        datas?.attributes?.Image?.data?.attributes?.url
                      }
                    />
                  </div>
                  <p className="txt8 text-center our-pro-con p-3">
                    {datas?.attributes?.Title}
                  </p>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurProducts;
